import { render, staticRenderFns } from "./RegisterItemRecommended.vue?vue&type=template&id=579e551c&"
import script from "./RegisterItemRecommended.vue?vue&type=script&lang=js&"
export * from "./RegisterItemRecommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports